/**
 * Type guard
 */
export const isLedgerGasTracker = (gasTrackerConfig) => {
    return (gasTrackerConfig === null || gasTrackerConfig === void 0 ? void 0 : gasTrackerConfig.type) === "ledger";
};
//# sourceMappingURL=types.js.map